import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router-dom"
import './index.css'
import App from './App.tsx'
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import reportWebVitals from './reportWebVitals'
import StyledEngineProvider from "@mui/material/StyledEngineProvider"
import CssBaseline from "@mui/material/CssBaseline"
import axios from "axios"
import { LocalizationProvider } from "@mui/x-date-pickers-pro"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { AuthProvider } from "./auth/authProvider"
import { GlobalStateProvider } from "./contexts/GlobalState";
import { LicenseInfo } from "@mui/x-license";
import { SnackbarProvider } from './contexts/SnackbarContext';
import { ConfirmDialogProvider } from './contexts/confirmDialogContext';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import ErrorBoundary from './components/common/ErrorBoundry.tsx';
const env = window.location.host
if (env.includes("localhost")) {
  axios.defaults.baseURL = ""
  //axios.defaults.baseURL = "http://localhost:3000";
} else {
  axios.defaults.baseURL = `https://${env}`
}

const queryClient = new QueryClient();
LicenseInfo.setLicenseKey(
  "ca692007615d68cabf703fadc10d1d76Tz0xMTAxMTAsRT0xNzc0MTM3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="
)





const theme = createTheme({
  typography: {
    fontFamily: '"Noto Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
  },
});




createRoot(document.getElementById('root')!).render(
  <AuthProvider>
    <StyledEngineProvider injectFirst>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter basename="/veg/">
            <StrictMode>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <GlobalStateProvider>
                  <SnackbarProvider>
                    <ConfirmDialogProvider>                      
                      <ErrorBoundary>
                          <App />
                      </ErrorBoundary>
                    </ConfirmDialogProvider>

                  </SnackbarProvider>

                </GlobalStateProvider>
              </LocalizationProvider>
            </StrictMode>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </StyledEngineProvider>
  </AuthProvider>,
)

// If you want to start measuring performance in your app, pass a function
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()